import './styles.scss'

import React, { useState } from 'react'
import PropTypes from 'prop-types'

import ReadMore from 'lib/components/read-more'
import I18n from 'lib/i18n'
import { exceedsMax } from 'lib/utils/exceeds-max'

const MAX_LINES = 8
const MAX_HEIGHT = 176

const AboutTeacher = ({ teacherDescription, teacherEducation, teacherExperience }) => {
  const [expandedItem, setExpandedItem] = useState(null)

  const handleToggle = currentExpandableItemId => {
    setExpandedItem(previousExpandableItemId =>
      previousExpandableItemId === currentExpandableItemId ? null : currentExpandableItemId
    )
  }

  const aboutMeAreaExceedMax = exceedsMax('.about-section .about-me-container .read-more-text', MAX_HEIGHT)
  const educationAreaExceedMax = exceedsMax('.about-section .education-container .read-more-text', MAX_HEIGHT)
  const experienceAreaExceedMax = exceedsMax('.about-section .experience-container .read-more-text', MAX_HEIGHT)

  return (
    <div className='about-section'>
      {teacherDescription && (
        <div className='about-me-container'>
          <div className='title'>{I18n.t('profiles.show_info.description')}</div>
          <ReadMore
            id='about-me'
            onToggle={handleToggle}
            isExpanded={expandedItem === 'about-me'}
            text={teacherDescription}
            numberOfLines={MAX_LINES}
            noButton={!aboutMeAreaExceedMax}
          />
        </div>
      )}

      {teacherEducation && (
        <div className='education-container'>
          <div className='title'>{I18n.t('profiles.show_info.education')}</div>
          <ReadMore
            id='education'
            onToggle={handleToggle}
            isExpanded={expandedItem === 'education'}
            text={teacherEducation}
            numberOfLines={MAX_LINES}
            noButton={!educationAreaExceedMax}
          />
        </div>
      )}

      {teacherExperience && (
        <div className='experience-container'>
          <div className='title'>{I18n.t('profiles.show_info.experience')}</div>
          <ReadMore
            id='experience'
            onToggle={handleToggle}
            isExpanded={expandedItem === 'experience'}
            text={teacherExperience}
            numberOfLines={MAX_LINES}
            noButton={!experienceAreaExceedMax}
          />
        </div>
      )}
    </div>
  )
}

AboutTeacher.propTypes = {
  teacherDescription: PropTypes.string,
  teacherEducation: PropTypes.string,
  teacherExperience: PropTypes.string
}

export default AboutTeacher
